import AppNavbar from "@/components/common/AppNavbar";
import Breadcrumbs from "@/components/common/Breadcrumbs";
import RegisterForm from "@/components/forms/FleetRegistrationForm";

export default function RegisterFleet() {
  return (
    <>
      <AppNavbar />
      <div className="bg-base-100 pt-16">
        <Breadcrumbs />
        <div className="flex min-h-screen flex-col items-center bg-base-200 px-4 py-6 sm:p-6">
          <div className="w-full max-w-4xl rounded-lg bg-base-100 p-4 shadow sm:p-6 lg:p-8">
            <RegisterForm />
          </div>
        </div>
      </div>
    </>
  );
}
